import { writable } from 'svelte/store';
import type { PostAttrs, PostAttrsArray } from './post.type';

const postSchema: PostAttrs = {
	id: '',
	created_by: '',
	author: '',
	location: '',
	title: '',
	description: '',
	objective: '',
	topic: '',
	published: false,
	public: false,
	contents: '',
	slug: '',
	event_location: '',
	event_date_start: undefined,
	event_date_end: undefined,
	event_time_start: undefined,
	event_time_end: undefined,
	created_at: undefined,
	updated_at: undefined,
	image_url: '',
	community: '',
	website: '',
	type: undefined,
	participants: 0,
	hours: 0.0,
	member_participants: [],
	impacts: [
		{
			text: '',
			id: ''
		}
	],
	actionvalidated: null,
	needs_more_info: null,
	membersonly: false,
	digs: 0,
	contributor_members: [],
	bounty_posted: false,
	claim_id: ''
};

export const postStore = writable<PostAttrs>(postSchema);
export const posts = writable<PostAttrsArray>([postSchema]);
export const postOwner = writable<boolean>(false);
